import WeaLocaleProvider from "../../wea-locale-provider";
import { defultCkConfig, defaultAtwhoConfig } from "../propType";
import { lanOfCk } from "./lan";

const { getUserLanguage } = WeaLocaleProvider;

export const convertSpecialChar = str => {
  str = str.toString();
  str = str.replace(/<br>/gi, "\n");
  str = str.replace(/&nbsp;/gi, " ");
  str = str.replace(/&lt;/gi, "<");
  str = str.replace(/&gt;/gi, ">");
  str = str.replace(/&quot;/gi, '"');
  str = str.replace(/&amp;/gi, "&");
  return str;
};

export const restoreSpeicalStr = str => {
  str = str.toString();
  //需先转译
  str = str.replace(/&/gi, "&amp;");
  str = str.replace(/</gi, "&lt;");
  str = str.replace(/>/gi, "&gt;");
  //后转译
  str = str.replace(/\n/gi, "<br>");
  str = str.replace(/ /gi, "&nbsp;");
  str = str.replace(/\"/gi, "&quot;");
  return str;
};

// 内容转换
export const transfStr = (type, ids, list, lev2Type) => {
  let str = "";
  list.forEach(item => {
    if (type === "Upload" && lev2Type === "image") {
      str += `<img src="${item.imgSrc}" alt="" />&#8203;`;
    }
    if (type === "Upload" && (lev2Type === "file" || lev2Type === "list")) {
      str +=
        `<a onclick="ecCom.WeaRichText.opendoc1(this,${item.fileid})" unselectable="off"` +
        'style="cursor:pointer;text-decoration:underline !important;margin-right:8px"' +
        `href="javascript:void(0);" contenteditable="false">${item.filename}</a>&#8203;`;
      if (item.showLoad) {
        str +=
          `&nbsp;<a unselectable='off' contenteditable='false'` +
          `href='javascript:try{downloadFile(\"${item.loadlink}\","${item.fileid}")}catch(e){window.open(\"${item.loadlink}\")}' ` +
          `style='cursor:pointer;text-decoration:underline;margin-right:8px'>下载(${item.filesize})</a><br>`;
      }
    }
    if (type === "Browser") {
      str +=
        `<a contenteditable='false' onclick="ecCom.WeaRichText.openAppLink(this,${item.id},${lev2Type})"` +
        'href="javascript:void(0);" unselectable="off" contenteditable="false"' +
        'style="cursor:pointer;text-decoration:underline !important;margin-right:8px">' +
        `${item.name || item.showname}</a>&#8203;`;
    }
  });
  return str;
};

// hash 生成id
export const getHash = () =>
  Math.random()
    .toString(36)
    .substr(2, 6);

export const clearEmptyChar = data =>
  data.replace(/[\u200B-\u200D\uFEFF]/g, "").replace("&#8203;", "");

// 过滤默认传入的带div的标签
export const filterValueOfDiv = data => {
  const preReg = new RegExp(/^<div id=\"wea_rich_text_default_font\"[^>]+\>/);
  if (preReg.test(data)) {
    return data.replace(preReg, "").replace(/<\/div>$/, "");
  }
  return data;
};

// 当前系统语言
export const getLang = () =>
  ({
    7: "zh-cn",
    8: "en",
    9: "zh"
  }[getUserLanguage()]);

// 得到默认字体 默认字体大小相关属性
export const checkDefaultFont = config => {
  if (!config) return {};
  // 1、直接通过ckeditor的属性 fontSize_defaultLabel， font_defaultLabel传的配置
  // 2、流程签字意见通过约定的属性fontSize_defaultSize， font_defaultFamily作为默认字体和字体大小的配置
  const {
    fontSize_defaultLabel,
    font_defaultLabel,
    fontSize_defaultSize,
    font_defaultFamily
  } = config;
  const fontFamily =
    font_defaultLabel ||
    (font_defaultFamily && font_defaultFamily.split("/")[1]) ||
    "";
  const fontSize =
    fontSize_defaultLabel ||
    (fontSize_defaultSize && fontSize_defaultSize.split("/")[1]);
  return {
    hasDefaultFontFamily:
      fontFamily && config.font_names.indexOf(fontFamily) > 0,
    fontFamily,
    hasDefaultFontSize: fontSize && config.fontSize_sizes.indexOf(fontSize) > 0,
    fontSize
  };
};

// 判断toolbar 是否有相关的配置属性
export const fillterToolbarStr = (toolbar, value) => {
  if (!toolbar || toolbar.length === 0) return false;
  const str = JSON.stringify(toolbar);
  return str.indexOf(value) > -1;
};

// Maximize Image 扩展判断 （渲染组件内部代码）
export const filterToolbar = toolbar => {
  let toolbarArr = toolbar;
  const hasMaximize = fillterToolbarStr(toolbarArr, "Maximize");
  const hasImage = fillterToolbarStr(toolbarArr, "Image");
  const hasVideo = fillterToolbarStr(toolbarArr, "Html5video");
  if (hasMaximize || hasImage || hasVideo) {
    toolbarArr = toolbarArr.map(tool => {
      let _tool = Array.isArray(tool) ? [].concat(tool) : { ...tool };
      if (Array.isArray(tool))
        _tool = tool.filter(
          item =>
            item !== "Maximize" && item !== "Image" && item !== "Html5video"
        );
      if (_tool.items)
        _tool.items = tool.items.filter(
          item =>
            item !== "Maximize" && item !== "Image" && item !== "Html5video"
        );
      return _tool;
    });
  }
  return toolbarArr;
};

// 获取最终ckConfig
export const getConfig = ckConfig => {
  const { font_en, font_zh, uploadUrl } = defultCkConfig;
  const defaultConfig = {
    ...defultCkConfig,
    language: getLang(),
    lanOfCk,
    font_names: getLang() === "en" ? font_en + font_zh : font_zh + font_en,
    uploadUrl:
      ckConfig.uploadUrl && ckConfig.uploadUrl !== ""
        ? ckConfig.uploadUrl
        : uploadUrl
  };
  let extraPlugins = [
    "clipboard",
    "autolink",
    "openlink",
    "image2",
    "pastetools",
    "pastefromword",
    "imagepaste",
    "uploadimage"
    // "imageresizerowandcolumn"
  ];
  if (ckConfig.extraPlugins) {
    const extra = ckConfig.extraPlugins.split(",");
    extraPlugins = [...extraPlugins, ...extra];
  }
  if (ckConfig.placeholder) {
    // placeholder
    extraPlugins = [...extraPlugins, "confighelper"];
  }
  if (JSON.stringify(ckConfig.toolbar).indexOf("textindent") > -1) {
    // 首行缩进
    extraPlugins = [...extraPlugins, "textindent"];
  }

  let config = {
    ...defaultConfig,
    ...ckConfig,
    removePlugins: ckConfig.removePlugins
      ? `magicline,${ckConfig.removePlugins}`
      : "magicline", // magicline: 去掉红色分割线
    extraPlugins: extraPlugins.join(","),
    toolbar: filterToolbar(ckConfig.toolbar)
  };
  const defaultFontPrams = checkDefaultFont(config);
  if (defaultFontPrams.hasDefaultFontFamily) {
    config = {
      ...config,
      font_defaultLabel: defaultFontPrams.fontFamily,
      fontSize_defaultLabel: defaultFontPrams.fontSize
    };
  }
  return config;
};

// 获取默认字体 默认字体大小的div
export const connectDataWithDiv = (ckConfig, content) => {
  const {
    hasDefaultFontFamily,
    fontFamily,
    hasDefaultFontSize,
    fontSize
  } = checkDefaultFont(ckConfig);
  if ((hasDefaultFontFamily || hasDefaultFontSize) && content) {
    const pre = '<div id="wea_rich_text_default_font" style="';
    let style = "";
    if (hasDefaultFontFamily) {
      style += `font-family:${fontFamily};`;
    }
    if (hasDefaultFontSize) {
      style += `font-size:${fontSize};`;
    }
    content = `${pre}${style}">${content}</div>`;
  }
  return content;
};

// 过滤extentsConfig中 at相关配置
export const getAtConfigInExtendsConfig = extentsConfig =>
  extentsConfig.filter(item => item.name === "At")[0];

// get atwho config
export const getAtwhoConfig = (extentsConfig, otherConfig) => {
  const configInExtendsConfig = getAtConfigInExtendsConfig(extentsConfig);
  const apiRequest =
    !configInExtendsConfig.data || configInExtendsConfig.data.length === 0; // 是否走接口请求@数据 - 默认传了data表示渲染传入的数据
  let atwhoConfig = {
    ...configInExtendsConfig, // 通过props的extentsConfig传入的@相关配置
    ...defaultAtwhoConfig, // 默认的config
    ...otherConfig, // 组件内部才能拿到的方法和事件
    isEn: getLang() === "en",
    pageSize: configInExtendsConfig.pageSize || defaultAtwhoConfig.pageSize,
    apiRequest
  };
  if (!apiRequest) {
    // 传入的data 匹配atwho.js 需要的数据格式
    let allatids = ",";
    const filterData = configInExtendsConfig.data.map(
      ({ uid, data, datapy }) => {
        if (allatids.indexOf("," + uid + ",") === -1) {
          allatids += uid + ",";
          return { id: uid, name: data, py: datapy };
        }
      }
    );
    atwhoConfig = {
      ...atwhoConfig,
      data: filterData
    };
  }
  return atwhoConfig;
};



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/util/index.js